<div class="missing-account-type-banner">
  <div class="missing-account-type-banner__illustration-wrapper">
    <img
      class="missing-account-type-banner__illustration"
      src="assets/images/inheritance-document-checklist/missing-account-type-illustration.png"
      alt=""
      data-cy="missing-account-type-illustration"
    />
  </div>
  <div class="missing-account-type-banner__content">
    <div class="missing-account-type-banner__text">
      <p
        class="c11n-text-lg-headline missing-account-type-banner__heading"
        data-cy="missing-account-type-heading"
      >
        {{ content.heading }}
      </p>
      <p class="c11n-text-md" data-cy="missing-account-type-body-1">
        {{ content.body1 }}
      </p>
      <p class="c11n-text-md" data-cy="missing-account-type-body-2">
        {{ content.body2Before }}
        <strong>{{ content.body2Link }}</strong>{{ content.body2After }}
      </p>
    </div>
    <c11n-button
      [labelText]="content.buttonLabel"
      data-cy="start-transfer-button"
      [fullWidth]="true"
      (clickEvent)="onStartTransfer()"
    ></c11n-button>
  </div>
</div>
